/* eslint-disable */

type MockedClassExtensions = {
    mockClearAll: () => void;
    mockResetAll: () => void;
};

declare global {
    namespace jest {}
}

export function mockClass<T>(constructor: new (...args: any[]) => T): jest.Mocked<T> & MockedClassExtensions {
    const instance: any = {};
    const properties = Object.getOwnPropertyNames(constructor.prototype).filter(prop => prop !== 'constructor');

    properties.forEach(prop => (instance[prop] = jest.fn()));
    instance.mockClearAll = (): void => properties.forEach(prop => instance[prop].mockClear());
    instance.mockResetAll = (): void => properties.forEach(prop => instance[prop].mockReset());
    return instance;
}
